import api from './index'
// 创建订阅增值业务订单 https://yapi.zeekrlife.com/project/851/interface/api/83059
export const create = (...arg) => api.post('/otherOrder/create', ...arg)

// 是否存在已支付且在服务时间内的订单 https://yapi.zeekrlife.com/project/851/interface/api/83052
export const checkValidOrder = (...arg) => api.post('/otherOrder/checkValidOrder', ...arg)

// 查询网易严选联合会员信息 https://yapi.zeekrlife.com/project/851/interface/api/83066
export const queryNetEasyJointMember = (...arg) => api.post('/otherOrder/queryNetEasyJointMember', ...arg)

// 复购券包活动查询
export const queryRepurchaseCoupon = (...arg) => api.post('/eventActivity/repurchaseCoupon/queryList', ...arg)

// 复购券包活动购买
export const payRepurchaseCoupon = (...arg) => api.post('/otherOrder/repurchaseCoupon/pay', ...arg)
